import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { UploadIcon } from 'lucide-react';
import { useRef } from 'react';

type ReuploadButtonProps = {
  disabled?: boolean;
  onSelectFiles: (files: File[]) => void;
  accept?: string;
  'aria-label'?: string;
  className?: string;
};

export function ReuploadButton({
  disabled = false,
  onSelectFiles,
  accept = 'image/*',
  className,
  'aria-label': ariaLabel = 'Re-upload',
}: ReuploadButtonProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={className}>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => {
          const files = e.target.files ? Array.from(e.target.files) : [];
          if (files.length) {
            onSelectFiles(files as File[]);
          }
          if (inputRef.current) {
            inputRef.current.value = '';
          }
        }}
      />
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="sm"
            variant="ghost"
            className="rounded-xl h-9 px-4 bg-sidebar-accent/50 hover:bg-sidebar-accent transition-all font-bold text-xs gap-2 border border-sidebar-border/30 shadow-sm active:scale-95"
            onClick={() => inputRef.current?.click()}
            disabled={disabled}
            aria-label={ariaLabel}
          >
            <UploadIcon size={14} className="text-primary" />
            <span>{ariaLabel}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{ariaLabel}</TooltipContent>
      </Tooltip>
    </div>
  );
}


